/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as AppDataStoreActions from './app-data-store.actions';

/* State key */
export const featureKey = 'AppDataStore';

/* State interface */
export interface AppState {
  selectedTabIndexForEditTourPage?: number;
  activeTourId?: string;
}

/* Initial values */
export const initialState: AppState = {
  selectedTabIndexForEditTourPage: 0,
  activeTourId: null,
};

export const reducer = createReducer(
  initialState,
  on(
    AppDataStoreActions.UpdateSelectedTabIndexForEditTourPage,
    (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  ),
);
